import {apiPlugin, StoryblokVue} from '@storyblok/vue';
import {defineNuxtPlugin, useRuntimeConfig} from '#app';

export default defineNuxtPlugin({
  name: 'storyblok:init',
  enforce: 'pre',
  parallel: true,

  setup({vueApp}) {
    const config = useRuntimeConfig().public;

    vueApp.use(StoryblokVue, {
      ...config.storyblok,
      accessToken: config.storyblok.accessToken || config.storyblokConfig.accessToken,
      use: [apiPlugin],
    });
  },
});
